"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gaugeSchemaValidator = exports.gaugeRangeSchemaValidator = void 0;
const zod_1 = require("zod");
const common_1 = require("./common");
const number_utils_1 = require("../../../utils/number.utils");
exports.gaugeRangeSchemaValidator = zod_1.z.object({
    color: zod_1.z.string().min(1),
    label: zod_1.z.string().min(1),
    start: zod_1.z.number(),
    end: zod_1.z.number(),
});
exports.gaugeSchemaValidator = zod_1.z.intersection(common_1.commonTypeSchemaValidator, zod_1.z.object({
    metric_column_id: zod_1.z.string().min(1),
    needle_color: zod_1.z.string().min(1),
    value_prefix: zod_1.z.string().optional(),
    value_suffix: zod_1.z.string().optional(),
    filter: common_1.widgetFilterValidator.optional(),
    ranges: zod_1.z
        .array(exports.gaugeRangeSchemaValidator.refine(val => val.start <= val.end, {
        message: 'valor inicial não pode ser maior que valor final',
    }))
        .min(1)
        .transform((val, ctx) => {
        const sorted = val.sort((a, b) => a.start - b.start);
        if ((0, number_utils_1.numbersOverlap)(val)) {
            ctx.addIssue({
                code: 'custom',
                message: 'valores inicial e final não podem ter intersecção',
            });
            return [];
        }
        return sorted;
    }),
}));
